export default __webpack_public_path__ + "static/media/19.3a6c0fc5.jpg";